import React from 'react';

import Roles from 'constants/Roles';
import { Select } from 'v1/components/shared';

type RoleSelectorProps = {
  size?: 's' | 'm' | 'l';
  value?: boolean;
  onChange?: (isSuperUser: boolean) => void;
};

/**
 * Works with the isSuperUser property - true/false rather than strings or ids
 */
const RoleSelector = ({ size, value, onChange }: RoleSelectorProps) => {
  const formattedValue = value ? 'admin' : 'regular';
  const convertedSize = size ? size.toUpperCase() : undefined;

  const handleSelect = ({ target }: React.ChangeEvent<HTMLSelectElement>) => {
    onChange && onChange(target.value === 'admin');
  };

  return (
    // @ts-ignore - v1 component
    <Select size={convertedSize} value={formattedValue} onChange={handleSelect}>
      {Roles.map(r => (
        <option value={r.id} key={r.id}>
          {r.name}
        </option>
      ))}
    </Select>
  );
};

export default RoleSelector;
